import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import { anexoApi } from 'app/services/api/anexoApi';
import clsx from 'clsx';
import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import ReactImageGallery from 'react-image-gallery';

const useStyles = makeStyles({
  carouselImg: {
    height: 300,
    display: 'flex',
    justifyContent: 'center',
    '& a > img': {
      height: 300,
    },
  },
  carouselThumb: {
    height: 88,
    '&.active': {
      boxShadow:
        '0px 1px 5px 0px rgba(84, 198, 232,0.4), 0px 2px 2px 0px rgba(84, 198, 232,0.44), 0px 3px 1px -2px rgba(84, 198, 232,0.52)',
      border: '0px',
    },
    '&:hover, &:focus': {
      border: '0px solid #000',
    },
    '&.image-gallery-thumbnail.active': {
      border: '0px solid #000',
      backgroundColor: 'rgba(84, 198, 232,0.12)',
    },
    '&.image-gallery-icon:hover,.image-gallery-icon:focus': {
      border: '0px solid #000',
    },
    '& div': {
      height: 80,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& div > img': {
      height: 80,
      width: 'auto !important',
    },
  },
  arrow: {
    top: '50%',
    transform: 'translateY(-50%)',
    position: 'absolute',
    zIndex: 3,
  },
  leftArrow: {
    left: 0,
  },
  righArrow: {
    right: 0,
  },
});

const Carousel = ({ images = [], allowDownload = false, urlAnexoApi }) => {
  const styles = useStyles();

  let startIndex = images?.findIndex((imagem) => imagem.principal);

  startIndex = startIndex !== -1 ? startIndex : 0;

  const onDownload = async (image) => {
    const response = await anexoApi().downloadAnexo(`${urlAnexoApi}/${image.id}`);
    const contentType = response.headers['content-type'];
    const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', image.nome);
    document.body.appendChild(link);

    link.click();
  };

  return (
    <ReactImageGallery
      startIndex={startIndex}
      items={images?.map((img) => ({
        original: img.url,
        thumbnail: img.thumbUrl,
        originalClass: styles.carouselImg,
        thumbnailClass: clsx(styles.carouselThumb, 'shadow-1', 'rounded-4', 'pl-2', 'pr-2'),
        renderItem: (item) => (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            {allowDownload && (
              <Tooltip title="Download" placement="bottom">
                <IconButton
                  aria-label="download"
                  style={{
                    marginRight: '10px',
                  }}
                  onClick={() => onDownload(img)}
                >
                  <CloudDownload size="lg" />
                </IconButton>
              </Tooltip>
            )}
            <a href={item.original} data-lightbox={`imagens-produto-${item.original}`}>
              <img className={styles.carouselImg} src={item.original} alt={item.originalAlt} />
            </a>
          </div>
        ),
      }))}
      renderLeftNav={(onClick) => (
        <IconButton color="primary" onClick={onClick} className={clsx(styles.arrow, styles.leftArrow, 'shadow-2')}>
          <FaChevronLeft />
        </IconButton>
      )}
      renderRightNav={(onClick) => (
        <IconButton color="primary" onClick={onClick} className={clsx(styles.arrow, styles.righArrow, 'shadow-2')}>
          <FaChevronRight />
        </IconButton>
      )}
      showPlayButton={false}
      showFullscreenButton={false}
    />
  );
};

export default Carousel;
